(() => {
const displayTitle=(value,sku)=>{const title=String(value||'');const match=title.match(/^(\d{3,})(_[^\s]+)?\s+/);return match&&(match[2]||match[1]===String(sku||'').split(/[_-]/)[0])?title.slice(match[0].length).trim()||title:title;};
  const identities = new Map();
  const identity = item => JSON.stringify([String(item.variant_id || item.id),Object.entries(item.properties || {}).filter(([,v])=>v!==null&&v!=='').sort(([a],[b])=>a.localeCompare(b)),item.selling_plan_allocation?.selling_plan?.id || null]);
  function group(items) {
    const groups = new Map();
    for (const item of items) {
      if (!(Number(item.quantity) > 0)) continue;
      const token=identity(item);
      identities.set(item.key, token);
      if (!groups.has(token)) groups.set(token,{...item,quantity:0,final_line_price:0,original_line_price:0});
      const row=groups.get(token);
      row.quantity+=item.quantity;
      row.final_line_price+=item.final_line_price;
      row.original_line_price+=item.original_line_price;
    }
    return [...groups.values()];
  }
  async function change(payload, api) {
    const cart=await api('cart.js');
    const exact=cart.items.find(item=>item.key===payload.id);
    const token=identities.get(payload.id) || (exact && identity(exact));
    if (!token) throw Error('Your bag changed. Please refresh it and try again.');
    const matches=cart.items.filter(item=>identity(item)===token);
    if (!matches.length) throw Error('This item is no longer in your bag.');
    const desired=Math.max(0,Math.floor(Number(payload.quantity)||0));
    if(matches.length===1 || !payload.groupQuantity) {
      const response=await fetch((window.Oblivion?.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:exact?.key||matches[0].key,quantity:desired})});
      const result=await response.json();
      if(!response.ok)throw Error(result.description||'Unable to update quantity.');
      return result;
    }
    let remaining=desired;
    const updates=cart.items.map(item=>{
      if(identity(item)!==token)return item.quantity;
      const quantity=Math.min(remaining,item.quantity);
      remaining-=quantity;
      return quantity;
    });
    if(remaining)updates[cart.items.indexOf(matches[0])]+=remaining;
    return api('cart/update.js',{updates});
  }
  const escape=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function renderPage(cart) {
    const holder=document.querySelector('[data-cart-page] .cart-page-items');
    if(!holder)return;
    const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:cart.currency||'INR'}).format(n/100);
    holder.innerHTML=group(cart.items).map(item=>`<article class="cart-page-item"><a href="${escape(item.url)}"><img src="${escape(item.image||item.featured_image?.url||'')}" alt="${escape(displayTitle(item.product_title,item.sku))}" width="150" height="150"></a><div><h2><a href="${escape(item.url)}">${escape(displayTitle(item.product_title,item.sku))}</a></h2>${item.variant_title&&item.variant_title!=='Default Title'?`<p class="muted">${escape(item.variant_title)}</p>`:''}<div class="quantity-control"><button data-cart-change="${escape(item.key)}" data-quantity="${item.quantity-1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button data-cart-change="${escape(item.key)}" data-quantity="${item.quantity+1}" aria-label="Increase quantity">+</button></div><button class="remove-link" data-cart-change="${escape(item.key)}" data-quantity="0">Remove</button></div><div class="cart-item-prices"><strong>${money(item.final_line_price)}</strong>${item.original_line_price>item.final_line_price?`<s>${money(item.original_line_price)}</s>`:''}</div></article>`).join('')+'<a class="text-link" href="/collections/all">Continue exploring</a>';
  }
  window.OblivionCartLines={group,change,identity};
  const init=async()=>{
    if(!document.querySelector('[data-cart-page]'))return;
    try{const response=await fetch((window.Oblivion?.root||'/')+'cart.js',{cache:'no-store'});if(response.ok)renderPage(await response.json());}catch(error){console.warn('Bag grouping unavailable',error);}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

